module.exports = __webpack_public_path__ + "static/media/kiril.a2647067.png";